// extracted by mini-css-extract-plugin
module.exports = {"chat":"styles_chat__DxpAw","inputDescription":"styles_inputDescription__S8wIZ"};